



 let resourcedata = {
"Enum3608.Text":"0,1,2,3,4,5,6,7,8,9,11",
"Enum3608.0.Text":"System Objects",
"Enum3608.1.Text":"Spaces",
"Enum3608.2.Text":"Chillers",
"Enum3608.3.Text":"Air Handlers",
"Enum3608.4.Text":"Programmable Controllers",
"Enum3608.5.Text":"Chiller Plants",
"Enum3608.6.Text":"Heat Pump Loops",
"Enum3608.7.Text":"Points",
"Enum3608.8.Text":"Building Controllers",
"Enum3608.9.Text":"Air Systems",
"Enum3608.11.Text":"Areas",
//Units text
"Enum3047.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,117,118,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,112,113,114,62,63,64,65,66,110,111,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,115,116,86,87,88,89,90,91,92,93,94,95,96,97,98,99,120,100,101,102,103,104,105,119,156,256,257,258,259,260,261,262,166,10263",
"Enum3047.0.Text":"Square Meters",
"Enum3047.1.Text":"Square Feet",
"Enum3047.10.Text":"Megavolt Amperes",
"Enum3047.100.Text":"Per Minute",
"Enum3047.101.Text":"Per Second",
"Enum3047.102.Text":"PSI per Degree Fahrenheit",
"Enum3047.103.Text":"Radians",
"Enum3047.104.Text":"Revolutions per Minute",
"Enum3047.105.Text":"MBH: Thousands of BTUH",
"Enum3047.11.Text":"Volt Amperes Reactive",
"Enum3047.110.Text":"Minutes per Degree Fahrenheit",
"Enum3047.111.Text":"Minutes per Degree Celsius",
"Enum3047.112.Text":"Kilograms Force per Square Centimeter",
"Enum3047.113.Text":"Feet of Water Column",
"Enum3047.114.Text":"Millimeters of Water",
"Enum3047.115.Text":"Cubic Meters per Minute",
"Enum3047.116.Text":"Cubic Meters per Hour",
"Enum3047.117.Text":"Kilocalories per Kilogram Dry Air",
"Enum3047.118.Text":"Kilojoules per Kilogram Dry Air",
"Enum3047.119.Text":"Units Unknown",
"Enum3047.12.Text":"Kilovolt Amperes Reactive",
"Enum3047.13.Text":"Megavolt Amperes Reactive",
"Enum3047.14.Text":"Degrees Phase",
"Enum3047.15.Text":"Power Factor",
"Enum3047.16.Text":"Joules",
"Enum3047.17.Text":"Kilojoules",
"Enum3047.18.Text":"Watt Hours",
"Enum3047.19.Text":"Kilowatt Hours",
"Enum3047.2.Text":"Milliamperes",
"Enum3047.20.Text":"BTU",
"Enum3047.21.Text":"Therm",
"Enum3047.22.Text":"Ton Hour",
"Enum3047.23.Text":"Joules per Kilogram Dry Air",
"Enum3047.24.Text":"BTU per Pound Dry Air",
"Enum3047.25.Text":"Cycles per Hour",
"Enum3047.256.Text":"Hundreds of CFM",
"Enum3047.257.Text":"Thousands of CFM",
"Enum3047.258.Text":"Fahrenheit Temperature Differential",
"Enum3047.259.Text":"Celsius Temperature Differential",
"Enum3047.26.Text":"Cycles per Minute",
"Enum3047.260.Text":"Percent Open",
"Enum3047.261.Text":"Percent Heating",
"Enum3047.262.Text":"Percent Cooling",
"Enum3047.27.Text":"Hertz",
"Enum3047.28.Text":"Grams Water per Kilogram Dry Air",
"Enum3047.29.Text":"Percent Relative Humidity",
"Enum3047.3.Text":"Amperes",
"Enum3047.30.Text":"Millimeters",
"Enum3047.31.Text":"Meters",
"Enum3047.32.Text":"Inch",
"Enum3047.33.Text":"Feet",
"Enum3047.34.Text":"Watts per Square Foot",
"Enum3047.35.Text":"Watts per Square Meter",
"Enum3047.36.Text":"Lumen",
"Enum3047.37.Text":"LUX",
"Enum3047.38.Text":"Foot Candles",
"Enum3047.39.Text":"Kilograms",
"Enum3047.4.Text":"Ohms",
"Enum3047.40.Text":"Pounds Mass",
"Enum3047.41.Text":"Tons",
"Enum3047.42.Text":"Kilograms Mass per Second",
"Enum3047.43.Text":"Kilograms Mass per Minute",
"Enum3047.44.Text":"Kilograms Mass per Hour",
"Enum3047.45.Text":"Pounds Mass per Minute",
"Enum3047.46.Text":"Pounds Mass per Hour",
"Enum3047.47.Text":"Watts",
"Enum3047.48.Text":"Kilowatts",
"Enum3047.49.Text":"Megawatts",
"Enum3047.5.Text":"Volts",
"Enum3047.50.Text":"Btu per Hour",
"Enum3047.51.Text":"Horsepower",
"Enum3047.52.Text":"Tons Refrigeration",
"Enum3047.53.Text":"Pascals",
"Enum3047.54.Text":"Kilopascals",
"Enum3047.55.Text":"Bar",
"Enum3047.56.Text":"Pounds Force per Square Inch",
"Enum3047.57.Text":"Centimeters Of Water",
"Enum3047.58.Text":"Inches of Water",
"Enum3047.59.Text":"Millimeters of Mercury",
"Enum3047.6.Text":"Kilovolts",
"Enum3047.60.Text":"Centimeters of Mercury",
"Enum3047.61.Text":"Inches of Mercury",
"Enum3047.62.Text":"Degrees Celsius",
"Enum3047.63.Text":"Degrees Kelvin",
"Enum3047.64.Text":"Degrees Fahrenheit",
"Enum3047.65.Text":"Degree Days Celsius",
"Enum3047.66.Text":"Degree Days Fahrenheit",
"Enum3047.67.Text":"Year",
"Enum3047.68.Text":"Month",
"Enum3047.69.Text":"Week",
"Enum3047.7.Text":"Megavolts",
"Enum3047.70.Text":"Day",
"Enum3047.71.Text":"Hour",
"Enum3047.72.Text":"Minute",
"Enum3047.73.Text":"Second",
"Enum3047.74.Text":"Meters per Second",
"Enum3047.75.Text":"Kilometers per Hour",
"Enum3047.76.Text":"Feet per Second",
"Enum3047.77.Text":"Feet per Minute",
"Enum3047.78.Text":"Miles per Hour",
"Enum3047.79.Text":"Cubic Feet",
"Enum3047.8.Text":"Volt Amperes",
"Enum3047.80.Text":"Cubic Meters",
"Enum3047.81.Text":"Imperial Gallons",
"Enum3047.82.Text":"Liters",
"Enum3047.83.Text":"Gallons",
"Enum3047.84.Text":"Cubic Feet per Minute",
"Enum3047.85.Text":"Cubic Meters per Second",
"Enum3047.86.Text":"Imperial Gallons per Minute",
"Enum3047.87.Text":"Liters per Second",
"Enum3047.88.Text":"Liters per Minute",
"Enum3047.89.Text":"Gallons per Minute",
"Enum3047.9.Text":"Kilovolt Amperes",
"Enum3047.90.Text":"Degrees",
"Enum3047.91.Text":"Degrees Celsius per Hour",
"Enum3047.92.Text":"Degrees Celsius per Minute",
"Enum3047.93.Text":"Degrees Fahrenheit per Hour",
"Enum3047.94.Text":"Degrees Fahrenheit per Minute",
"Enum3047.96.Text":"Parts per Million",
"Enum3047.97.Text":"Parts per Billion",
"Enum3047.98.Text":"Percent",
"Enum3047.99.Text":"Percent per Second",
"Enum3047.120.Text":"Delta Degrees Fahrenheit",
"Enum3047.121.Text":"Delta Degrees Celsius",
"Enum3047.156.Text":"Ton Refrigeration Hours",
"Enum3047.166.Text":"Meters per Second per Second",
"Enum3047.10263.Text":"Feet per Second per Second",
//Units Symbol
"Enum3046.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,118,24,117,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,112,114,57,58,113,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,115,116,86,87,88,89,90,91,92,93,94,110,111,95,96,97,98,99,100,101,102,103,104,105,119,156,256,257,258,259,260,261,262",
"Enum3046.0.Text":"m2",
"Enum3046.1.Text":"ft2",
"Enum3046.10.Text":"MVA",
"Enum3046.100.Text":"per min",
"Enum3046.101.Text":"per sec",
"Enum3046.10110.Text":"min/°F",
"Enum3046.10111.Text":"min/°C",
"Enum3046.10112.Text":"kg/cm2",
"Enum3046.10113.Text":"ft W.C.",
"Enum3046.10114.Text":"mm W.C.",
"Enum3046.10117.Text":"kcal/kg",
"Enum3046.102.Text":"PSI/°F",
"Enum3046.10259.Text":"°C",
"Enum3046.10263.Text":"ft/s2",
"Enum3046.103.Text":"rad",
"Enum3046.104.Text":"RPM",
"Enum3046.105.Text":"MBTUH",
"Enum3046.11.Text":"V A reactive",
"Enum3046.110.Text":"min/°F",
"Enum3046.111.Text":"min/°C",
"Enum3046.112.Text":"kg/cm2",
"Enum3046.113.Text":"ft W.C.",
"Enum3046.114.Text":"mm W.C.",
"Enum3046.115.Text":"m3/min",
"Enum3046.116.Text":"m3/h",
"Enum3046.117.Text":"kcal/kg",
"Enum3046.118.Text":"kJ/kg",
"Enum3046.156.Text":" TonRfg/h",
"Enum3046.12.Text":"kV A reactive",
"Enum3046.120.Text":"°F",
"Enum3046.121.Text":"°C",
"Enum3046.13.Text":"MV A reactive",
"Enum3046.135.Text":"m3/h",
"Enum3046.14.Text":"deg phase",
"Enum3046.149.Text":"kJ/kg",
"Enum3046.15.Text":"power factor",
"Enum3046.16.Text":"J",
"Enum3046.165.Text":"m3/min",
"Enum3046.166.Text":"m/s2",
"Enum3046.17.Text":"kJ",
"Enum3046.18.Text":"WH",
"Enum3046.19.Text":"kWH",
"Enum3046.2.Text":"mA",
"Enum3046.20.Text":"Btu",
"Enum3046.21.Text":"therm",
"Enum3046.22.Text":"ton hr",
"Enum3046.23.Text":"J/kg",
"Enum3046.24.Text":"BTU/lb",
"Enum3046.25.Text":"CPH",
"Enum3046.256.Text":"CCFM",
"Enum3046.257.Text":"KCFM",
"Enum3046.258.Text":"°F",
"Enum3046.259.Text":"°C",
"Enum3046.26.Text":"CPM",
"Enum3046.260.Text":"%open",
"Enum3046.261.Text":"%heat",
"Enum3046.262.Text":"%cool",
"Enum3046.27.Text":"Hz",
"Enum3046.28.Text":"g H2O/kg",
"Enum3046.29.Text":"% RH",
"Enum3046.3.Text":"A",
"Enum3046.30.Text":"mm",
"Enum3046.31.Text":"m",
"Enum3046.32.Text":"in",
"Enum3046.33.Text":"ft",
"Enum3046.34.Text":"W/ft2",
"Enum3046.35.Text":"W/m2",
"Enum3046.36.Text":"lumen",
"Enum3046.37.Text":"LUX",
"Enum3046.38.Text":"ft Candles",
"Enum3046.39.Text":"kg",
"Enum3046.4.Text":"ohms",
"Enum3046.40.Text":"lbs",
"Enum3046.41.Text":"Tons",
"Enum3046.42.Text":"kg mass/sec",
"Enum3046.43.Text":"kg mass/min",
"Enum3046.44.Text":"kg mass/hr",
"Enum3046.45.Text":"lb mass/min",
"Enum3046.46.Text":"lb mass/hr",
"Enum3046.47.Text":"W",
"Enum3046.48.Text":"kW",
"Enum3046.49.Text":"MW",
"Enum3046.5.Text":"V",
"Enum3046.50.Text":"Btu/hr",
"Enum3046.51.Text":"hp",
"Enum3046.52.Text":"Tons Refrigeration",
"Enum3046.53.Text":"Pa",
"Enum3046.54.Text":"kPa",
"Enum3046.55.Text":"bar",
"Enum3046.56.Text":"PSI",
"Enum3046.57.Text":"cm W.C.",
"Enum3046.58.Text":"in  W.C.",
"Enum3046.59.Text":"mm Hg",
"Enum3046.6.Text":"kV",
"Enum3046.60.Text":"cm Hg",
"Enum3046.61.Text":"in Hg",
"Enum3046.62.Text":"°C",
"Enum3046.63.Text":"°K",
"Enum3046.64.Text":"°F",
"Enum3046.65.Text":"deg days C",
"Enum3046.66.Text":"deg days F",
"Enum3046.67.Text":"yr",
"Enum3046.68.Text":"mon",
"Enum3046.69.Text":"wk",
"Enum3046.7.Text":"MV",
"Enum3046.70.Text":"day",
"Enum3046.71.Text":"hr",
"Enum3046.72.Text":"min",
"Enum3046.73.Text":"sec",
"Enum3046.74.Text":"m/sec",
"Enum3046.75.Text":"km/hr",
"Enum3046.76.Text":"ft/sec",
"Enum3046.77.Text":"ft/min",
"Enum3046.78.Text":"MPH",
"Enum3046.79.Text":"ft3",
"Enum3046.8.Text":"VA",
"Enum3046.80.Text":"m3",
"Enum3046.81.Text":"imp gal",
"Enum3046.82.Text":"l",
"Enum3046.83.Text":"gal",
"Enum3046.84.Text":"CFM",
"Enum3046.85.Text":"m3/s",
"Enum3046.86.Text":"imp GPM",
"Enum3046.87.Text":"L/s",
"Enum3046.88.Text":"L/min",
"Enum3046.89.Text":"GPM",
"Enum3046.9.Text":"kVA",
"Enum3046.90.Text":"deg",
"Enum3046.91.Text":"°C/hr",
"Enum3046.92.Text":"°C/min",
"Enum3046.93.Text":"°F/hr",
"Enum3046.94.Text":"°F/min",
"Enum3046.96.Text":"ppm",
"Enum3046.97.Text":"ppb",
"Enum3046.98.Text":"%",
"Enum3046.99.Text":"%/sec"

}

export default class DMResources {

  static FamilyList(value) {          // Returning List of Currencies
    return resourcedata[value];
  }

}